export const map = {
  draw: true,
  layers: true,
  mapViews: true,
  measure: true,
  print: false,
  share: true,
};

export const list = {
  folders: true,
  save: true,
  print: true,
};

export const details = {
  reports: true,
  videos: true,
  photos: true,
  print: true,
  files: true,
  share: true,
};



// WEBPACK FOOTER //
// ./src/featureConfig.js